<!-- Botones flotantes que aparecen al hacer scroll -->
<div class="floating-buttons" [class.floating-buttons--visible]="isScrolled">
  <button class="floating-buttons__button floating-buttons__button--primary" (click)="openAutoApertura()">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="floating-buttons__icon">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
    </svg>
    <span class="floating-buttons__text">Solicitar Unipay</span>
  </button>

  <button class="floating-buttons__button floating-buttons__button--secondary" (click)="openPagoEstadoCuenta()">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" stroke="currentColor" class="floating-buttons__icon">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
    </svg>
    <span class="floating-buttons__text">Pagar estado cuenta</span>
  </button>
</div>
